<div class="card" id="card" #card (click)="onClick()">
  <div class="card__header">
    <p class="card__text" [hidden]="minimo">Você tem</p>
    <p class="card__cacaus"><img class="img__cacau" src="assets/images/icons/cacau_moeda.png" alt="">{{ pontuacao }} <span [hidden]="minimo">{{ pontuacao > 1 ? "Cacaus" : "Cacau" }}</span></p>
  </div>
  <div class="card__footer" [hidden]="minimo">
    <p *ngIf="idNivel != 9">R$20,00 = <img class="" src="assets/images/icons/cacau_moeda.png" alt=""> 1 Cacau</p>
    <p *ngIf="idNivel == 9">Ganhe cacaus completando as missões!</p>
  </div>
</div>
